import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function ExchangeDifferenceCalculationsGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default ExchangeDifferenceCalculationsGenericSkeleton;
